import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import UserDetails from '../../../../../UserDetails';
import DetailsTable from '../../../../TransactionsPage/DetailsTable';
import {StyledTransactionDetails} from './StyledTransactionDetails';
import {useMCCCategory} from '../../../../../../hooks';
import {transactionsHelpers} from '../../../../../../utils/helpers';

const TransactionDetails = ({
  transaction,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'transactions']);

  const category = useMCCCategory(transaction?.mcc_code);

  const employees = useSelector(state => state.company.employees || []);

  const reportedBy = employees.find(emp => emp.employee_id === transaction?.user_id);

  const tableData = [
    {
      key: 'source',
      label: t('transactions:source'),
      value: transactionsHelpers.getTransactionSource(transaction),
    },
    {
      key: 'payment_method',
      label: `${t('payment')} ${t('method')}`,
      value: transactionsHelpers.getTransactionPaymentMethodDetails(transaction)
    },
    {
      key: 'paidBy',
      label: t('paidBy'),
      value: reportedBy && (
        <UserDetails
          avatarProps={{size: 24}}
          email={false}
          style={{display: 'flex', flexDirection: 'row-reverse'}}
          user={reportedBy}
        />
      )
    },
    {
      key: 'mcc',
      label: t('MCC'),
      value: category?.name || '-'
    }
  ]

  return (
    <StyledTransactionDetails {...rest}>
      <DetailsTable data={tableData} />
    </StyledTransactionDetails>
  );
}

TransactionDetails.propTypes = {
  transaction: PropTypes.object,
}

export default TransactionDetails;
